import { useForm } from "react-hook-form";
//primereact
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";

import Input from "../../../components/input/Input";
import { toast } from "react-toastify";
import { useState } from "react";
import { postConfigKey } from "../../../services/Enterprise/ClickSign/postConfigKey";

const ModalCreateKey = ({ visible, setVisible, refetch }) => {
  const {
    control: control,
    handleSubmit: handleClick,
    reset,
    formState: { errors },
    setValue,
  } = useForm();

  const [loading, setLoading] = useState(false);

  function sendKeyIntegration(data) {
    setLoading(true);

    const notification = toast.loading(
      "Por favor, aguarde a ação está sendo realizada..."
    );
    postConfigKey(data)
      .then(() => {
        refetch().then(() => {
          setLoading(false);
          toast.update(notification, {
            render: "Chave cadastrada com sucesso!",
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            type: "success",
            isLoading: false,
          });
        });
      })
      .catch((error) => {
        setLoading(false);
        toast.update(notification, {
          render: "Não foi possível cadastrar chave de integração!",
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          type: "error",
          isLoading: false,
        });
      })
      .finally(() => {
        setVisible(false);
        reset();
      });
  }

  const getFormErrorMessage = (name) => {
    return errors[name] ? (
      <small className="p-error">{errors[name].message}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };

  return (
    <>
      <Dialog
        header="Chave de Integração"
        id="modal_cad"
        className="rounded-4"
        onHide={() => setVisible(false)}
        visible={visible}
        style={{ width: window.innerWidth <= 992 ? "85vw" : "70vw" }}
      >
        <Divider align="left">
          <div className="inline-flex align-items-center">
            <i className="pi pi-user mr-2"></i>
            <b> Informações para Integração ClickSign</b>
          </div>
        </Divider>
        <form onSubmit={handleClick(sendKeyIntegration)}>
          <div className="px-3">
            <div className="row">
              <div className="col-md-6 mb-3 form-group">
                <Input
                  isRequired={true}
                  name="name_token"
                  control={control}
                  label="Nome para Identificação"
                  getFormErrorMessage={getFormErrorMessage}
                />
              </div>
              <div className="col-md-6 mb-3 form-group">
                <Input
                  isRequired={true}
                  name="access_token"
                  control={control}
                  label="Token de Acesso"
                  getFormErrorMessage={getFormErrorMessage}
                />
              </div>
              <div className="text-center">
                <Button
                  loading={loading}
                  rounded
                  label="Adicionar"
                  icon="fa fa-plus"
                  type="submit"
                  className="p-inputtext-sm m-auto"
                />
              </div>
            </div>
          </div>
        </form>
      </Dialog>
    </>
  );
};

export default ModalCreateKey;
